import React, { useRef, useEffect, useLayoutEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
  ROW_JUSTIFY,
  COL_SPAN,
  ROUTER_BASENAME,
  SESSION_STORAGE_INVITE_CODE,
} from "../common/const";
import { GetLoginStatus } from "../config/request";
import {
  UrlQueryParamsParse,
  CheckSystem,
  googleStatis,
  getNextPathByRegisterStatus,
} from "../common/globalFun";

import PageBg from "../components/PageBg";

import "./css/style.css";

const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />;

const AdminPage = (props) => {
  const { history } = props;
  const hasOrgCodeRef = useRef(false); // 邀请链接过来的
  const isFromEmailInvite = useRef(false); // 邀请邮件过来的
  const isLocationClient = useRef(false); // 是否客户端打开的非登录页面, 防止登录页面一闪而过

  const getUrlParam = (paramName) => {
    const { search, hash } = window.location;
    let urlQuery = search;

    if (!urlQuery) {
      urlQuery = hash.slice(hash.indexOf("?"), hash.length);
    }

    const urlQuertParamsStr = urlQuery.replace(/^\?/, "");
    const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr);

    if (queryParamsData && queryParamsData[paramName]) {
      const urlParam = decodeURIComponent(queryParamsData[paramName]);

      return urlParam;
    } else {
      return "";
    }
  };

  const checkSessionStorage = () => {
    const inviteCode = sessionStorage.getItem(SESSION_STORAGE_INVITE_CODE);
    if (inviteCode) {
      props.setGlobalInviteCode(inviteCode);
    }
  };

  const checkUrlParam = () => {
    const url = getUrlParam("redirectUri") || getUrlParam("redirect_url");

    if (url) {
      props.setGlobalRedirectUri(url);
    }

    const orgCode = getUrlParam("orgCode");

    if (orgCode) {
      hasOrgCodeRef.current = true;
      props.setGlobalCorpId(orgCode);
    }
    const inviteCode = getUrlParam("inviteCode");
    const recommend = getUrlParam("recommend");
    const register = getUrlParam("register");
    if (recommend) {
      window.sessionStorage.setItem("recommend", recommend);
    }

    if (inviteCode) {
      props.setGlobalInviteCode(inviteCode);
      sessionStorage.setItem(SESSION_STORAGE_INVITE_CODE, inviteCode);
    }
    if (register) {
      sessionStorage.setItem("register", true);
    }
    // sns 登录
    const email = getUrlParam("register_email");

    if (email) {
      console.log("set email", email);
      props.setGlobalEmail(email);
      checkSessionStorage();
    }

    const token = getUrlParam("register_token");

    if (token) {
      props.setGlobalToken(token);
      const registerStatis = getUrlParam("register_status");
      switch (Number(registerStatis)) {
        case 2:
          history.push("/signin_org");
          props.setGlobalQuickRegister(true);
          return;
        default:
          break;
      }
    }

    const loginKey = getUrlParam("login_key");

    if (loginKey) {
      props.setGlobalLoginKey(loginKey);
      history.push("/download");
      return;
    }

    const quickRegister = getUrlParam("quick_register");

    if (quickRegister) {
      props.setGlobalQuickRegister(!!JSON.parse(quickRegister));
    }

    // 邮件邀请过来的 (注: 会自动登录上)
    const account = getUrlParam("email");
    if (account) {
      isFromEmailInvite.current = true;
      props.setGlobalEmail(account);
    }

    const emailCheckKey = getUrlParam("email_check_key");
    if (emailCheckKey) {
      props.setGlobalEmailCheckKey(emailCheckKey);
      history.replace({
        pathname: "/set_pwd",
        data: { nextPath: "/invite_list" },
      });
      return;
    }

    checkLogin();
  };

  const checkLogin = () => {
    if (CheckSystem.Felo()) {
      if (!isLocationClient.current) return;

      setTimeout(() => {
        // 判断是否跳转过
        if (history.location.pathname === "/") {
          history.replace("/login");
        }
      }, 0);
      return;
    }

    const url = getUrlParam("redirectUri") || getUrlParam("redirect_url");
    // 当是第三方登录 返回地址关闭弹窗
    // if (url && url.indexOf("/login_popup_callback") > -1) {
    //   history.replace("/login_popup_callback");
    //   return;
    // }

    GetLoginStatus().then((rsp) => {
      if (rsp.isLogin) {
        // 统计
        googleStatis("sns_success", { email: props.email });

        if (hasOrgCodeRef.current) {
          // 当新账号注册未创建组织时调用team.list会报错
          GetLoginStatus({ status_type: "register" }).then((data) => {
            const { status, accountList } = data;
            const account = accountList[0];
            props.setGlobalEmail(account);
            props.setGlobalQuickRegister(true);
            const nextPath = getNextPathByRegisterStatus(status);
            history.replace(nextPath);
          });
          return;
        }

        if (rsp.hasInvite) {
          history.push("/invite_list");
        } else {
          // 第三方注册走这里
          GetLoginStatus({ status_type: "register" }).then((data) => {
            const { status, accountList } = data;
            const nextPath = getNextPathByRegisterStatus(status);
            props.setGlobalEmail(accountList[0]);
            props.setGlobalQuickRegister(true);
            history.push(nextPath);
          });
          return;
        }
      } else {
        history.replace("/login");
      }
    });
  };

  useEffect(() => {
    // check login after check url param
    checkUrlParam();
  }, []);

  useLayoutEffect(() => {
    // 如果已跳转到其他页则不检测
    if (history.location.paramName && history.location.paramName != "/") return;

    // 兼容客户端页面 旧的hash方式路由
    const locationHash = window.location.hash;
    if (locationHash) {
      if (locationHash === "#_=_") {
        // fix facebook redirect url, do nothing
      } else {
        // hash client history
        window.location.href =
          window.location.origin +
          `/${ROUTER_BASENAME}` +
          locationHash.replace("#", "");
        return;
      }
    }

    isLocationClient.current = true;
  }, []);

  return (
    <>
      <PageBg />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full main-content`}
      >
        <Col span={COL_SPAN} className="content-center">
          <Spin indicator={antIcon} />
        </Col>
      </Row>
    </>
  );
};

const stateProps = (state) => {
  return {};
};

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: "setToken",
      value: token,
    });
  },
  setGlobalRedirectUri: (url) => {
    console.log("set redirect url:", url);
    dispatch({
      type: "setRedirectUri",
      value: url,
    });
  },
  setGlobalCorpId: (id) => {
    dispatch({
      type: "setCorpId",
      value: id,
    });
  },
  setGlobalInviteCode: (code) => {
    console.log("set invite code", code);
    dispatch({
      type: "setInviteCode",
      value: code,
    });
  },
  setGlobalLoginKey: (key) => {
    dispatch({
      type: "setLoginKey",
      value: key,
    });
  },
  setGlobalEmail: (email) => {
    dispatch({
      type: "setEmail",
      value: email,
    });
  },
  setGlobalQuickRegister: (value) => {
    dispatch({
      type: "setQuickRegister",
      value: value,
    });
  },
  setGlobalEmailCheckKey: (key) => {
    dispatch({
      type: "setEmailCheckKey",
      value: key,
    });
  },
});

export default connect(stateProps, dispatchProps)(AdminPage);
